/**
 * NotificationErrorState — mevcut cabin.error.* genel key'lerini yeniden kullanır
 * (yeni key icat edilmedi).
 */
import { RefreshCw } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

export default function NotificationErrorState({ onRetry }) {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col items-center gap-3 py-10 px-4 text-center">
      <p className="text-sm font-bold text-[var(--text-main)]">{t('cabin.error.title')}</p>
      <p className="text-xs text-[var(--text-secondary)]">{t('cabin.error.sub')}</p>
      <button
        type="button"
        onClick={onRetry}
        className="flex items-center gap-1.5 text-xs font-semibold text-[var(--brand-primary)] hover:underline min-h-[44px] px-2 rounded focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
      >
        <RefreshCw size={14} aria-hidden="true" />
        {t('cabin.error.cta')}
      </button>
    </div>
  );
}
